import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsNotificationEmailRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-notifications-notification-email',
	path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
	exact: true,
};
